module.exports = __webpack_public_path__ + "img/step-4.ec4f01bd.jpg";